// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-header {
  color: #424242;
}

/* Fond principal avec effet glassmorphism */
ion-content {
  --background: linear-gradient(135deg, #9ba5ff 0%, #4846b8 50%, #0c2061 100%);
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}

/* Effet de particules animées en arrière-plan */
ion-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 60% 60%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 10% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 90% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%);
  animation: float 15s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  25% {
    transform: translateY(-10px) translateX(5px);
  }
  50% {
    transform: translateY(0) translateX(10px);
  }
  75% {
    transform: translateY(10px) translateX(5px);
  }
}
/* Header avec glassmorphism */
ion-header {
  position: relative;
  z-index: 10;
}

ion-toolbar {
  --background: rgba(255, 255, 255, 0.1);
  --color: white;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

ion-title {
  font-weight: 600;
  font-size: 1.3rem;
  letter-spacing: 0.5px;
}

ion-buttons ion-icon {
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

ion-buttons ion-icon:hover {
  transform: translateX(-2px);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
}

/* Container principal */
.page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 80%;
  padding: 2rem 1rem;
  position: relative;
  z-index: 1;
}

/* Carte glassmorphism pour le formulaire */
.boxForm {
  width: 95%;
  max-width: 450px;
  margin-bottom: 2rem;
  border-radius: 20px;
  padding: 2.5rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.boxForm::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s;
}

.boxForm:hover::before {
  left: 100%;
}

.boxForm:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(31, 38, 135, 0.5);
}

/* Styling des champs de saisie */
ion-item {
  --background: rgba(255, 255, 255, 0.9);
  --border-radius: 12px;
  --inner-padding-start: 16px;
  --inner-padding-end: 16px;
  --padding-start: 0;
  --padding-end: 0;
  margin-bottom: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  font-size: 1rem;
}

ion-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

ion-item.item-has-focus {
  --background: rgba(255, 255, 255, 0.95);
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* Labels flottants améliorés */
ion-label {
  --color: #636e72;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

ion-item.item-has-focus ion-label {
  --color: #667eea;
  font-weight: 600;
}

/* Champs de saisie */
ion-input {
  --color: #2d3436;
  --placeholder-color: #636e72;
  font-size: 1rem;
  font-weight: 500;
}

/* Messages d'erreur */
ion-text[color=danger] {
  font-size: 0.85rem;
  margin-top: 0.5rem;
  display: block;
  padding: 0.5rem;
  background: rgba(244, 67, 54, 0.1);
  border-radius: 6px;
  border-left: 3px solid #f44336;
}

/* Container des boutons */
.buttons-container {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  gap: 1rem;
  margin-top: 1rem;
  max-width: 450px;
}

/* Boutons modernes */
.btn {
  width: 45%;
  min-width: 120px;
  height: 3.5rem;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Bouton principal (Valider) */
.btn:not(.btn-secondary) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn:not(.btn-secondary):hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
}

.btn:not(.btn-secondary):disabled {
  background: linear-gradient(135deg, #cccccc 0%, #999999 100%);
  cursor: not-allowed;
  opacity: 0.6;
}

/* Bouton secondaire (Annuler) */
.btn.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.btn.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

/* Effet de brillance sur les boutons */
.btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn:active {
  transform: translateY(0);
}

/* Zone de confirmation */
.confirmation-container {
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.confirmation-box {
  text-align: center;
  color: white;
}

.confirmation-box p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.confirmation-box .btn {
  width: auto;
  min-width: 160px;
  margin: 0 auto;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.boxForm {
  animation: fadeInUp 0.6s ease-out;
}

/* Animation de secousse pour les erreurs */
@keyframes shake {
  0%, 20%, 40%, 60%, 80%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
}
.shake {
  animation: shake 0.5s ease-in-out;
}

/* Responsive design */
@media (max-width: 768px) {
  .page {
    padding: 1rem 0.5rem;
  }
  .boxForm {
    width: 98%;
    padding: 2rem;
  }
  .buttons-container {
    flex-direction: column;
    gap: 1rem;
  }
  .btn {
    width: 100%;
    height: 3rem;
    font-size: 1rem;
  }
  ion-item {
    font-size: 0.95rem;
  }
}
/* Animation d'entrée progressive pour les éléments */
.boxForm > *:nth-child(1) {
  animation-delay: 0.1s;
}

.boxForm > *:nth-child(2) {
  animation-delay: 0.2s;
}

.boxForm > *:nth-child(3) {
  animation-delay: 0.3s;
}

.boxForm > *:nth-child(4) {
  animation-delay: 0.4s;
}

/* Style pour le zoom */
form[style*="zoom:0.8"] {
  transform: scale(0.9);
  transform-origin: center top;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/form-inscription/form-inscription.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACA,cAAA;AAEA;;AACA,4CAAA;AACA;EACI,4EAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;;AACE,gDAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gqBACE;EAQF,yCAAA;EACA,UAAA;EACA,oBAAA;AANJ;;AASE;EACE;IACE,sCAAA;EANJ;EAQE;IACE,4CAAA;EANJ;EAQE;IACE,yCAAA;EANJ;EAQE;IACE,2CAAA;EANJ;AACF;AASE,8BAAA;AACA;EACE,kBAAA;EACA,WAAA;AAPJ;;AAUE;EACE,sCAAA;EACA,cAAA;EACA,2BAAA;EACA,mCAAA;EACA,iDAAA;AAPJ;;AAUE;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;AAPJ;;AAUE;EACE,YAAA;EACA,iDAAA;EACA,iDAAA;AAPJ;;AAUE;EACE,2BAAA;EACA,iDAAA;AAPJ;;AAUE,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAPJ;;AAUE,2CAAA;AACA;EACE,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,8CAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;;AAUE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AAPJ;;AAUE;EACE,UAAA;AAPJ;;AAUE;EACE,2BAAA;EACA,8CAAA;AAPJ;;AAUE,iCAAA;AACA;EACE,sCAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,iDAAA;EACA,6BAAA;EACA,eAAA;AAPJ;;AAUE;EACE,2BAAA;EACA,0CAAA;AAPJ;;AAUE;EACE,uCAAA;EACA,qBAAA;EACA,8CAAA;AAPJ;;AAUE,+BAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;AAPJ;;AAUE;EACE,gBAAA;EACA,gBAAA;AAPJ;;AAUE,qBAAA;AACA;EACE,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAPJ;;AAUE,sBAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,8BAAA;AAPJ;;AAUE,0BAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAPJ;;AAUE,qBAAA;AACA;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;;AAUE,+BAAA;AACA;EACE,6DAAA;EACA,+CAAA;AAPJ;;AAUE;EACE,2BAAA;EACA,+CAAA;AAPJ;;AAUE;EACE,6DAAA;EACA,mBAAA;EACA,YAAA;AAPJ;;AAUE,gCAAA;AACA;EACE,oCAAA;EACA,0CAAA;EACA,mCAAA;UAAA,2BAAA;AAPJ;;AAUE;EACE,oCAAA;EACA,2BAAA;EACA,yCAAA;AAPJ;;AAUE,uCAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AAPJ;;AAUE;EACE,UAAA;AAPJ;;AAUE;EACE,wBAAA;AAPJ;;AAUE,yBAAA;AACA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAPJ;;AAUE;EACE,kBAAA;EACA,YAAA;AAPJ;;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;AAPJ;;AAUE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AAPJ;;AAUE,eAAA;AACA;EACE;IACE,UAAA;IACA,2BAAA;EAPJ;EASE;IACE,UAAA;IACA,wBAAA;EAPJ;AACF;AAUE;EACE,iCAAA;AARJ;;AAWE,2CAAA;AACA;EACE;IAA+B,wBAAA;EAPjC;EAQE;IAA0B,2BAAA;EAL5B;AACF;AAOE;EACE,iCAAA;AALJ;;AAQE,sBAAA;AACA;EACE;IACE,oBAAA;EALJ;EAQE;IACE,UAAA;IACA,aAAA;EANJ;EASE;IACE,sBAAA;IACA,SAAA;EAPJ;EAUE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EARJ;EAWE;IACE,kBAAA;EATJ;AACF;AAYE,qDAAA;AACA;EAA4B,qBAAA;AAT9B;;AAUE;EAA4B,qBAAA;AAN9B;;AAOE;EAA4B,qBAAA;AAH9B;;AAIE;EAA4B,qBAAA;AAA9B;;AAEE,uBAAA;AACA;EACE,qBAAA;EACA,4BAAA;AACJ","sourcesContent":["ion-header{\r\ncolor: #424242;\r\n}\r\n\r\n/* Fond principal avec effet glassmorphism */\r\nion-content {\r\n    --background: linear-gradient(135deg, #9ba5ff 0%, #4846b8 50%, #0c2061 100%);\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  /* Effet de particules animées en arrière-plan */\r\n  ion-content::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-image: \r\n      radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 60% 60%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 10% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 90% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%);\r\n    animation: float 15s ease-in-out infinite;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n  }\r\n  \r\n  @keyframes float {\r\n    0%, 100% { \r\n      transform: translateY(0) translateX(0);\r\n    }\r\n    25% { \r\n      transform: translateY(-10px) translateX(5px);\r\n    }\r\n    50% { \r\n      transform: translateY(0) translateX(10px);\r\n    }\r\n    75% { \r\n      transform: translateY(10px) translateX(5px);\r\n    }\r\n  }\r\n  \r\n  /* Header avec glassmorphism */\r\n  ion-header {\r\n    position: relative;\r\n    z-index: 10;\r\n  }\r\n  \r\n  ion-toolbar {\r\n    --background: rgba(255, 255, 255, 0.1);\r\n    --color: white;\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n  }\r\n  \r\n  ion-title {\r\n    font-weight: 600;\r\n    font-size: 1.3rem;\r\n    letter-spacing: 0.5px;\r\n  }\r\n  \r\n  ion-buttons ion-icon {\r\n    color: white;\r\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  }\r\n  \r\n  ion-buttons ion-icon:hover {\r\n    transform: translateX(-2px);\r\n    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));\r\n  }\r\n  \r\n  /* Container principal */\r\n  .page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    min-height: 80%;\r\n    padding: 2rem 1rem;\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n  \r\n  /* Carte glassmorphism pour le formulaire */\r\n  .boxForm {\r\n    width: 95%;\r\n    max-width: 450px;\r\n    margin-bottom: 2rem;\r\n    border-radius: 20px;\r\n    padding: 2.5rem;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n    box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .boxForm::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\r\n    transition: left 0.5s;\r\n  }\r\n  \r\n  .boxForm:hover::before {\r\n    left: 100%;\r\n  }\r\n  \r\n  .boxForm:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 12px 40px rgba(31, 38, 135, 0.5);\r\n  }\r\n  \r\n  /* Styling des champs de saisie */\r\n  ion-item {\r\n    --background: rgba(255, 255, 255, 0.9);\r\n    --border-radius: 12px;\r\n    --inner-padding-start: 16px;\r\n    --inner-padding-end: 16px;\r\n    --padding-start: 0;\r\n    --padding-end: 0;\r\n    margin-bottom: 1.5rem;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    border: 2px solid transparent;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  ion-item:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\r\n  }\r\n  \r\n  ion-item.item-has-focus {\r\n    --background: rgba(255, 255, 255, 0.95);\r\n    border-color: #667eea;\r\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\r\n  }\r\n  \r\n  /* Labels flottants améliorés */\r\n  ion-label {\r\n    --color: #636e72;\r\n    font-weight: 500;\r\n    font-size: 0.95rem;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  }\r\n  \r\n  ion-item.item-has-focus ion-label {\r\n    --color: #667eea;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  /* Champs de saisie */\r\n  ion-input {\r\n    --color: #2d3436;\r\n    --placeholder-color: #636e72;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  /* Messages d'erreur */\r\n  ion-text[color=\"danger\"] {\r\n    font-size: 0.85rem;\r\n    margin-top: 0.5rem;\r\n    display: block;\r\n    padding: 0.5rem;\r\n    background: rgba(244, 67, 54, 0.1);\r\n    border-radius: 6px;\r\n    border-left: 3px solid #f44336;\r\n  }\r\n  \r\n  /* Container des boutons */\r\n  .buttons-container {\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-evenly;\r\n    gap: 1rem;\r\n    margin-top: 1rem;\r\n    max-width: 450px;\r\n  }\r\n  \r\n  /* Boutons modernes */\r\n  .btn {\r\n    width: 45%;\r\n    min-width: 120px;\r\n    height: 3.5rem;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    text-transform: none;\r\n    cursor: pointer;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  /* Bouton principal (Valider) */\r\n  .btn:not(.btn-secondary) {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\r\n  }\r\n  \r\n  .btn:not(.btn-secondary):hover:not(:disabled) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n  }\r\n  \r\n  .btn:not(.btn-secondary):disabled {\r\n    background: linear-gradient(135deg, #cccccc 0%, #999999 100%);\r\n    cursor: not-allowed;\r\n    opacity: 0.6;\r\n  }\r\n  \r\n  /* Bouton secondaire (Annuler) */\r\n  .btn.btn-secondary {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border: 2px solid rgba(255, 255, 255, 0.3);\r\n    backdrop-filter: blur(10px);\r\n  }\r\n  \r\n  .btn.btn-secondary:hover {\r\n    background: rgba(255, 255, 255, 0.3);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\r\n  }\r\n  \r\n  /* Effet de brillance sur les boutons */\r\n  .btn::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n    transition: left 0.5s;\r\n  }\r\n  \r\n  .btn:hover::before {\r\n    left: 100%;\r\n  }\r\n  \r\n  .btn:active {\r\n    transform: translateY(0);\r\n  }\r\n  \r\n  /* Zone de confirmation */\r\n  .confirmation-container {\r\n    width: 100%;\r\n    height: 80%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .confirmation-box {\r\n    text-align: center;\r\n    color: white;\r\n  }\r\n  \r\n  .confirmation-box p {\r\n    font-size: 1.1rem;\r\n    line-height: 1.6;\r\n    margin-bottom: 2rem;\r\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  .confirmation-box .btn {\r\n    width: auto;\r\n    min-width: 160px;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n  /* Animations */\r\n  @keyframes fadeInUp {\r\n    from {\r\n      opacity: 0;\r\n      transform: translateY(30px);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n  \r\n  .boxForm {\r\n    animation: fadeInUp 0.6s ease-out;\r\n  }\r\n  \r\n  /* Animation de secousse pour les erreurs */\r\n  @keyframes shake {\r\n    0%, 20%, 40%, 60%, 80%, 100% { transform: translateX(0); }\r\n    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\r\n  }\r\n  \r\n  .shake {\r\n    animation: shake 0.5s ease-in-out;\r\n  }\r\n  \r\n  /* Responsive design */\r\n  @media (max-width: 768px) {\r\n    .page {\r\n      padding: 1rem 0.5rem;\r\n    }\r\n    \r\n    .boxForm {\r\n      width: 98%;\r\n      padding: 2rem;\r\n    }\r\n    \r\n    .buttons-container {\r\n      flex-direction: column;\r\n      gap: 1rem;\r\n    }\r\n    \r\n    .btn {\r\n      width: 100%;\r\n      height: 3rem;\r\n      font-size: 1rem;\r\n    }\r\n    \r\n    ion-item {\r\n      font-size: 0.95rem;\r\n    }\r\n  }\r\n  \r\n  /* Animation d'entrée progressive pour les éléments */\r\n  .boxForm > *:nth-child(1) { animation-delay: 0.1s; }\r\n  .boxForm > *:nth-child(2) { animation-delay: 0.2s; }\r\n  .boxForm > *:nth-child(3) { animation-delay: 0.3s; }\r\n  .boxForm > *:nth-child(4) { animation-delay: 0.4s; }\r\n  \r\n  /* Style pour le zoom */\r\n  form[style*=\"zoom:0.8\"] {\r\n    transform: scale(0.9);\r\n    transform-origin: center top;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
